<template>
  <div ref="teamPieChart" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';
  import 'echarts-gl';

  export default {
    props: ['data', 'height'],
    data() {
      return {
        style: '',
        myChart: {},
      };
    },
    created() {
      this.style = `width:100%; max-height:100%; min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
    },
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      this.myChart = echarts.init(this.$refs.teamPieChart);
      let option;
      option = {
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },

        baseOption: {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            // padding: 2,
            // orient: 'vertical',
            // right: 80,
            // top: 80,
          },
          series: [
            {
              name: 'Site Team Access Requests',
              type: 'pie',
              radius: '70%',
              label: {
                formatter: function(params) {
                  return params['data']['value'] > 0 ? params['data']['value'] : '';
                },
                position: 'inside',
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.data['My Action Required'],
                  name: 'Site Action Required',
                  itemStyle: {
                    color: '#FF9495',
                  },
                },
                {
                  value: this.data['In Progress'],
                  name: 'In Progress',
                  itemStyle: {
                    color: '#00B3FF',
                  },
                },
                {
                  value: this.data['Completed'],
                  name: 'Completed',
                  itemStyle: {
                    color: '#7070D6',
                  },
                },
              ],
            },
          ],
        },
      };

      option && this.myChart.setOption(option);
    },
  };
</script>

<style></style>
